import React, { useEffect, useCallback } from "react"
import { useLocation, useHistory } from "react-router-dom"

import CustomTabs from "../../v2-components/Antd/Tabs"

import MyUserForm from "./my-user"
import UsersTable from "./users"

import "./styles/common.css"

const UserManagement = () => {
    const location = useLocation()
    const history = useHistory()

    const getTabFromUrl = useCallback(() => {
        const searchParams = new URLSearchParams(location.search)
        return searchParams.get("tab") || "1"
    }, [location.search])

    const setTabInUrl = useCallback(
        (tabKey) => {
            const searchParams = new URLSearchParams(location.search)
            searchParams.set("tab", tabKey)
            history.push({
                pathname: location.pathname,
                search: searchParams.toString(),
            })
        },
        [history, location.pathname, location.search],
    )

    const activeKey = getTabFromUrl()

    const handleTabChange = (key) => {
        setTabInUrl(key)
    }

    useEffect(() => {
        if (!getTabFromUrl()) {
            setTabInUrl("1")
        }
    }, [getTabFromUrl, setTabInUrl])

    const tabItems = [
        {
            label: "Mi usuario",
            key: "1",
            children: <MyUserForm />,
        },
        {
            label: "Usuarios",
            key: "2",
            children: <UsersTable />,
        },
    ]

    return (
        <div className="container">
            <h1 className="page-title">Gestión de usuarios</h1>
            <CustomTabs activeKey={activeKey} onChange={handleTabChange} items={tabItems} />
        </div>
    )
}

export default React.memo(UserManagement)

